// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submit_mainDialog__sEdqA {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  min-width: 360px;
  width: 100%;
  direction: rtl;
}

.submit_header__hOrkC {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.7rem;
}

.submit_footer__qX3N4 {
  margin-top: 1.5rem;
  display: flex;
  gap: 1rem;
}

.submit_rowContainer__PmME1 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem 1rem;
}

.submit_gridContainer__9lZEw {
  justify-content: space-between;
  display: flex;
}

.submit_loadingContainer__qjRgx {
  margin: 0 auto;
}

.submit_gridItemContainer__jPBVp {
  padding: 1rem;
  border: 1px solid #DCDFE1;
  border-radius: 0.5rem;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(33.33% - 0.5rem);
}`, "",{"version":3,"sources":["webpack://./src/components/JobApplication/SubmitDialog/submit.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,aAAA;EACA,SAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AACJ;;AAEA;EACG,8BAAA;EACC,aAAA;AACJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EAAA,cAAA;EAAA,iCAAA;AAAJ","sourcesContent":[".mainDialog {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n    min-width: 360px;\n    width: 100%;\n    direction: rtl;\n}\n\n.header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 0.7rem;\n}\n\n.footer {\n    margin-top: 1.5rem;\n    display: flex;\n    gap: 1rem;\n}\n\n.rowContainer {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.3rem 1rem;\n}\n\n.gridContainer {\n   justify-content: space-between;\n    display: flex;\n}\n\n\n.loadingContainer {\n    margin: 0 auto;\n}\n\n.gridItemContainer {\n    padding: 1rem;\n    border: 1px solid #DCDFE1;\n    border-radius: 0.5rem;\n    flex: 0 0 calc(33.33% - 0.5rem);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainDialog": `submit_mainDialog__sEdqA`,
	"header": `submit_header__hOrkC`,
	"footer": `submit_footer__qX3N4`,
	"rowContainer": `submit_rowContainer__PmME1`,
	"gridContainer": `submit_gridContainer__9lZEw`,
	"loadingContainer": `submit_loadingContainer__qjRgx`,
	"gridItemContainer": `submit_gridItemContainer__jPBVp`
};
export default ___CSS_LOADER_EXPORT___;
